<template>
    <div style="padding-top: 15px;box-sizing: border-box;background-color: #f5f5f5;">
        <div class="agreement">
            <p class="task_name" @click="btnBototm">任务名称: <span class="task_txt">推广服务</span></p>
            <p class="task_name">任务周期 <span class="task_txt">按月更新,开始时间2024年9月15日</span></p>
            <p class="task_name">领取状态 <span class="task_txt1">{{showBtn ? '待领取' : '已领取'}}</span></p>
            <div class="task_all">
                <div class="task_yuan"></div>
                <div class="task_line"></div>
                <div class="task_yuan1"></div>
            </div>
            <p class="task_name">承包方 <span class="task_txt">深圳致复科技有限公司</span></p>
            <p class="task_name">任务描述 </p>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">协助平台推广平安银行贷款产品或服务等</div>
            </div>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">任务完成过程中遵守法律法规，符合平台各项规范要求</div>
            </div>
            <p class="task_name">任务要求</p>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">不向客户收取手续费，维护行业健康发展，君子爱财取之有道；</div>
            </div>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">不得包装，编造，伪造客户相关资料和数据。恶意、故包装需要严格杜绝;</div>
            </div>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">实事求是，不得误导;以免引起客诉，乃至个人形象品提供方的抹黑;</div>
            </div>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">接受此任务与您(或近亲属)主业无利益冲突或违反任何其他规范;</div>
            </div>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">经营登记者年龄大于18周岁,身份证所在地区非港澳台地区;</div>
            </div>
            <p class="task_name">温馨提示: <span
                    class="task_txt">若您推荐的客户取消贷款或者发现存在欺诈、违规等订单(具体以产品提供方认定为准)则上述订单对应佣金将不予计算，若您已提现的，您有义务配合合作机构原路退回</span>
            </p>
            <p class="task_name">产品详情</p>
            <p class="task_name">车主贷、车主贷车主惠贷、车主贷惠享</p>
            <p class="task_name">服务费:</p>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt">【12,36 ）期:放款金额*基础推广服务费率，其中，基础推广服务费率=0.77%+（执行成交利率-销售指导利率）*0.5*0.85；</div>
            </div>
            <div class="task_txt_all">
                <div class="task_txt_yuan"></div>
                <div class="task_txt"> 【36,60】期：放款金额*基础推广服务费率，其中，基础推广服务费率=1.53%+（执行成交利率-销售指导利率）*0.85；</div>
            </div>
            <p class="task_name">注：</p>
            <p class="task_name"><span
                    class="task_txt">1、“销售指导利率”为根据客户资质由银行系统批复的利率，“执行成交利率”为客户最终成交的贷款利率；
                </span></p>
            <p class="task_name"><span class="task_txt">2、“浮动服务费率”不上浮，即不可大于0：若执行成交利率-销售指导利率＞0的，则浮动服务费率直接计为0，该笔订单按照基础服务费率结算；</span></p>
            <p class="task_name"><span class="task_txt">3、若基础推广服务费率的计算值小于0的，则基础推广服务费率直接计为0；</span></p>
            <p class="task_name"><span class="task_txt">4、平安银行车主贷系列产品分为消费性贷款、经营性贷款两个类型（具体以客户实际申请为准），其中，针对经营性贷款类型的产品，设置特殊结算条件如下：</span></p>
            <p class="task_name"><span class="task_txt">（1）若客户在贷款发放之日起30天内（含30天）提前还款的，不予纳入服务费结算范围；</span></p>
            <p class="task_name"><span class="task_txt">（2）若客户在贷款发放之日起180天内（含180天）提前还款，且在该笔贷款发放180天以内（含180天）再次申请的，不予纳入服务费结算范围；</span></p>
            <p class="task_name"><span class="task_txt">（3）经营性贷款在T+2月开始结算；</span></p>

            <div style="width: 100%;background-color: #f2f2f2;padding: 10px;box-sizing: border-box;">
                <van-checkbox v-model="checked" shape="square" icon-size="16px">
                    <div style="display: flex;font-size: 12px;margin-top: 1px;">
                        <div>请同意并签署</div>
                        <div style="color: #e8a240;" @click.stop="btncontract">《平台个人经营者承包经营合同》</div>
                    </div>
                </van-checkbox>
                <div class="myButton" @click="btngetTask">领取任务</div>
            </div>
        </div>
    </div>
</template>

<script>
import URL from "@/api/api";
import { Toast, Dialog } from 'vant';
import {setSession } from '@/utils/utils'
export default {
    data() {
        return {
            checked: false,
            scrollTopVal: 0,
            tbUserId: '',
            showBtn: true
        };
    },
    mounted() {
        if (this.$route.query.flag == 1) {
            this.btnBototm();
        }
        this.tbUserId = this.$route.query.tbUserId
        this.userInfo()
    },
    methods: {
        btnBototm() {
            window.scrollBy(0, document.body.scrollHeight);
            this.checked = true
            // window.scrollTo({
            //     bottom: document.body.scrollHeight,
            //     behavior: 'smooth'
            // })
        },
        btngetTask() {
            if (this.checked) {
                this.$fetchGet(URL.getTask.url).then(res => {
                    if (res.data.code == 20000) {
                        this.$toast('领取成功');
                        this.$router.push({
                            path: '/',
                        });
                    } else {
                        this.$toast('领取失败');
                        this.$router.push({
                            path: '/',
                        });
                    }
                })
            } else {
                this.$toast('请同意并签署《平台个人经营者承包经营合同》');
            }

        },
        userInfo() {
            setSession("tbUserId", this.userId);
            this.$fetchGet(URL.getTuibaUserInfo.url, {userId: this.userId}).then(res => {
                if (res.data.code === 20000) {
                    if (res.data.data.signDate) {
                        this.showBtn = false
                        setSession("tbSignDate", res.data.data.signDate);
                    }
                    setSession("tbUserName", res.data.data.userName);
                    setSession("tbIdNo", res.data.data.idNo);
                    setSession("tbPhoneNo", res.data.data.phoneNo);
                }
            })
        },
        btncontract() {
            this.$router.push({
                path: '/contract',
            });
        }
    }
}
</script>

<style lang="less" scoped>
.agreement {
    box-sizing: border-box;
    margin: 0 15px;
    height: 100%;
    overflow: scroll;
    font-size: 14px;
    text-align: left;
    line-height: 2;
    background-color: #fff;
    border-radius: 7px;
    padding: 10px;
    margin-bottom: 100px;
}

.task_name {
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 5px;
}

.task_txt {
    font-weight: 500;
    line-height: 20px;
}

.task_txt1 {
    font-weight: 500;
    color: #caa364;
    line-height: 20px;
}

.task_all {
    display: flex;
    position: relative;
    margin-top: 10px;
    margin-bottom: 30px;
}

.task_yuan {
    position: absolute;
    left: -20px;
    width: 20px;
    height: 20px;
    background-color: #f5f5f5;
    border-radius: 10px;
}

.task_yuan1 {
    position: absolute;
    right: -20px;
    width: 20px;
    height: 20px;
    background-color: #f5f5f5;
    border-radius: 10px;
}

.task_line {
    position: absolute;
    top: 10px;
    width: 100%;
    border-bottom: 1px dashed #ccc;
}

.task_txt_all {
    display: flex;
    margin-left: 30px;
}

.task_txt_yuan {
    flex: 0 0 auto;
    margin-top: 6px;
    margin-right: 5px;
    box-sizing: border-box;
    width: 6px;
    height: 6px;
    background-color: #000;
    border-radius: 50%;
}

::-webkit-scrollbar {
    display: none;
}

.myButton {
    border: 0.02667rem solid #e9a13d;
    background: #e9a13d;
    padding: 1px 30px !important;
    text-align: center;
    margin-left: 50%;
    color: #fff;
    transform: translateX(-50%);
    margin-top: 20px;
    margin-bottom: 100px;
}
</style>